import { Instagram, Facebook, Linkedin } from "lucide-react";

// Small inline X (Twitter) icon (matches lucide's stroke style)
const XIcon = ({ className, strokeWidth = 1.5 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24"
        fill="none" stroke="currentColor" strokeWidth={strokeWidth}
        strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4 4l16 16M20 4L4 20"/>
  </svg>
);

const ICONS = {
  instagram: Instagram,
  facebook: Facebook,
  linkedin: Linkedin,
  x: XIcon,
};

const LABELS = { instagram: "Instagram", facebook: "Facebook", linkedin: "LinkedIn", x: "X" };

/**
 * Render social icons for a brand. Only icons corresponding to non-empty URLs
 * are rendered. Colours inherit from surrounding CSS (via `currentColor`),
 * so the icons naturally adopt the brand's theme.
 *
 * Props:
 * - urls: { instagram_url, facebook_url, linkedin_url, x_url }
 * - size: "sm" | "md" | "lg"  (icon size preset)
 * - className: extra wrapper classes
 */
export default function SocialLinks({ urls = {}, size = "md", className = "" }) {
  const entries = [
    { key: "instagram", url: urls.instagram_url },
    { key: "facebook", url: urls.facebook_url },
    { key: "linkedin", url: urls.linkedin_url },
    { key: "x", url: urls.x_url },
  ].filter(e => (e.url || "").trim().length > 0);
  if (entries.length === 0) return null;
  const iconSize = size === "lg" ? "w-5 h-5" : size === "sm" ? "w-3.5 h-3.5" : "w-4 h-4";
  return (
    <div className={`flex items-center gap-4 ${className}`} data-testid="brand-social-links">
      {entries.map(({ key, url }) => {
        const Icon = ICONS[key];
        return (
          <a key={key} href={url} target="_blank" rel="noopener noreferrer nofollow"
              title={LABELS[key]}
              className="opacity-70 hover:opacity-100 transition-opacity"
              data-testid={`brand-social-${key}`}>
            <Icon className={iconSize} strokeWidth={1.5}/>
          </a>
        );
      })}
    </div>
  );
}
